import { withAuthenticationRequired } from '@auth0/auth0-react';
import { useTranslation } from 'react-i18next';
import React, { useContext } from 'react';
import ResponsiveShipmentList from '@app/pages/carrier/shipments-list/ResponsiveShipmentList.tsx';
import ShipmentsLegacy from '@app/pages/carrier/shipments-list/ShipmentsLegacy.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';
import { AuthenticatedUserContext } from '@components/auth/AuthenticatedUser.tsx';
import { FeaturesEnum } from '@api/ringil-api.v2.tsx';
import { useLocalStorage } from '@utils/utils';

const PageShipments = () => {
  const { t } = useTranslation('common');
  const { hasFeature } = useContext(AuthenticatedUserContext);

  const [userOverride, setUserOverride] = useLocalStorage<boolean | null>('CarrierShipmentList.useNewVersionOverride', null);

  const shouldUseNewShipmentList =
    userOverride !== null ? userOverride : hasFeature([FeaturesEnum.MIGRATION_NEW_CARRIER_SHIPMENT_LIST]);

  return (
    <ResponsiveLayout title={t(`shipments.shipments`, `Shipments`)}>
      {shouldUseNewShipmentList ? <ResponsiveShipmentList /> : <ShipmentsLegacy />}
      <div className={'flex justify-center m-2'}>
        <button
          type={'button'}
          onClick={() => setUserOverride(!shouldUseNewShipmentList)}
          className={'text-xs text-content-tertiary underline hover:text-content-primary'}
        >
          {shouldUseNewShipmentList
            ? t(`shipments.switchToLegacyVersion`, `Switch to legacy version`)
            : t(`shipments.switchToNewVersion`, `Switch to new version`)}
        </button>
      </div>
    </ResponsiveLayout>
  );
};

export default withAuthenticationRequired(PageShipments);
